(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["srsly-new-bakery-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};
        this.setHeaderHeight();
        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        const observer = new IntersectionObserver((entries) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });
        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);
            this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        this.querySelectorAll('header-menu').forEach((disclosure) => disclosure.close());
      }

      closeSearchModal() {
        const searchModal = this.querySelector('details-modal');
        if (searchModal) searchModal.close(false);
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  const srslyRenderBasketCounts = (countValue) => {
    const count = Math.max(0, Number.parseInt(countValue, 10) || 0);
    const countText = String(count);
    const itemText = count === 1 ? '1 item' : `${count} items`;

    document.querySelectorAll('.srsly-header__cart-count').forEach((badge) => {
      if (badge.textContent.trim() !== countText) badge.textContent = countText;
    });

    ['cart-icon-bubble', 'mobile-cart-icon-bubble'].forEach((id) => {
      const cartElement = document.getElementById(id);
      if (!cartElement) return;

      let bubble = cartElement.querySelector('.cart-count-bubble');

      if (count < 1) {
        if (bubble) bubble.remove();
      } else {
        if (!bubble) {
          bubble = document.createElement(id === 'mobile-cart-icon-bubble' ? 'div' : 'span');
          bubble.className = 'cart-count-bubble';
          cartElement.appendChild(bubble);
        }

        const visibleBubbleCount = bubble.querySelector('[aria-hidden="true"]');
        if (!visibleBubbleCount || visibleBubbleCount.textContent.trim() !== countText) {
          bubble.innerHTML = `<span aria-hidden="true">${countText}</span><span class="visually-hidden">${itemText}</span>`;
        }
      }

      const cartLink = cartElement.closest('a');
      const hiddenCount = cartLink ? cartLink.querySelector(':scope > .visually-hidden:last-child') : null;
      if (hiddenCount && hiddenCount.textContent.trim() !== itemText) hiddenCount.textContent = itemText;
    });
  };

  const srslyFetchBasketCount = async () => {
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart.js`, {
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        cache: 'no-store'
      });

      if (!response.ok) return;

      const cart = await response.json();
      srslyRenderBasketCounts(cart.item_count);
    } catch (error) {
      // Keep the server-rendered count if the cart request is unavailable.
    }
  };

  const srslyScheduleBasketSync = () => {
    [0, 250, 750, 1500, 3000].forEach((delay) => {
      window.setTimeout(srslyFetchBasketCount, delay);
    });
  };

  srslyScheduleBasketSync();

  document.addEventListener('cart:updated', (event) => {
    const eventCount = event.detail && event.detail.cart
      ? event.detail.cart.item_count
      : null;

    if (eventCount !== null && eventCount !== undefined) {
      srslyRenderBasketCounts(eventCount);
    }

    srslyScheduleBasketSync();
  });

  ['cart:refresh', 'cart:change', 'cart:changed', 'cart:update'].forEach((eventName) => {
    document.addEventListener(eventName, srslyScheduleBasketSync);
  });
  window.addEventListener('pageshow', srslyScheduleBasketSync);

  /*
   * Watch the real cart requests. This works even when a cart-drawer app does
   * not dispatch Shopify's standard cart events or update its heading quickly.
   */
  const srslyIsCartRequest = (requestUrl) => {
    try {
      const url = new URL(String(requestUrl), window.location.origin);
      return /\/cart\/(add|change|update|clear)(\.js)?$/i.test(url.pathname);
    } catch (error) {
      return false;
    }
  };

  const srslyOriginalFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const response = await srslyOriginalFetch(...args);
    const requestUrl = args[0] instanceof Request ? args[0].url : args[0];

    if (srslyIsCartRequest(requestUrl)) {
      srslyScheduleBasketSync();
    }

    return response;
  };

  const srslyOriginalXhrOpen = XMLHttpRequest.prototype.open;
  const srslyOriginalXhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, requestUrl, ...rest) {
    this.srslyIsCartRequest = srslyIsCartRequest(requestUrl);
    return srslyOriginalXhrOpen.call(this, method, requestUrl, ...rest);
  };

  XMLHttpRequest.prototype.send = function(...args) {
    if (this.srslyIsCartRequest) {
      this.addEventListener('loadend', srslyScheduleBasketSync, { once: true });
    }

    return srslyOriginalXhrSend.apply(this, args);
  };

  /*
   * Some cart-drawer apps do not dispatch Shopify's cart events when an item
   * is removed or its quantity is changed. Detect those controls directly,
   * then re-read /cart.js after the drawer's own request has completed.
   */
  const srslyCartControlWasUsed = (event) => {
    const control = event.target.closest('button, a, input');
    if (!control) return;

    const controlDescription = [
      control.getAttribute('aria-label'),
      control.getAttribute('title'),
      control.getAttribute('name'),
      control.textContent
    ].filter(Boolean).join(' ').trim();

    const isCartAction = /\b(add to (basket|cart)|remove|delete)\b/i.test(controlDescription);
    const isQuantityControl = /\b(increase|decrease)\s+quantity\b/i.test(controlDescription);

    if (isCartAction || isQuantityControl) {
      srslyScheduleBasketSync();
    }
  };

  document.addEventListener('click', srslyCartControlWasUsed, true);

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;

    const inputDescription = [
      input.getAttribute('aria-label'),
      input.getAttribute('name')
    ].filter(Boolean).join(' ');

    if (/quantity/i.test(inputDescription) && input.closest('cart-drawer, [id*="cart-drawer" i], [class*="cart-drawer" i]')) {
      srslyScheduleBasketSync();
    }
  }, true);

  } catch(e) { console.error(e); }
})();
})();
